var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"Pc_ipad"},[_c('NavMenu')],1),_c('div',{staticClass:"phone"},[_c('Phone_Nav')],1),_c('div',{staticClass:"conent",style:({ paddingTop: _vm.top ? '140px' : '140px' })},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }